import get from 'lodash/get';
import map from 'lodash/map';
import size from 'lodash/size';

export default {
	get,
	map,
	size
};
